<template>
<div class="chapter">
<div class="inner_page">
<h1 id="heading_id_20">Acknowledgments</h1>
<p>I am grateful to Clare Heath-Whyte and Matthew Mason for commenting on the manuscript, to Andy Rees and David Heath-Whyte for help with the diagrams, and to Jonty Frith for suggesting the title.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?24fbd68f